export default __webpack_public_path__ + "static/media/Form.b504762f.png";